<template>
    <div>
        <button
            type="button"
            @click.prevent="openAlertModal"
            class="h-10 flex whitespace-nowrap items-center gap-x-1.5 rounded bg-white p-2.5 text-slate-800 text-sm font-medium shadow border border-slate-200 ring-gray-300 hover:bg-slate-200 active:bg-slate-200 focus:outline-slate-200 focus:border-slate-200 hover:border-slate-300 active:border-slate-300"
        >
            <Icon icon="plus" svgClass="w-5 h-5" />
            Create Alert
        </button>
        <ManageAlertModal
            :show="showAlertModal"
            @close="() => setShowAlertModal(false)"
        />
    </div>
</template>
<script>
import { mapState, mapActions } from 'pinia';
import { useAlertsStore } from '@/store/alerts';
import dayjs from 'dayjs';
import ManageAlertModal from '@/components/alerts/modals/manage-alert-modal/manage-alert-modal.vue';
import Icon from '@/components/ui/icon/icon.vue';

export default {
    components: {
        Icon,
        ManageAlertModal,
    },
    directives: {},
    props: {
        item: {
            type: [Object, null],
            default: null,
        },
    },
    data: () => ({
        errors: [],
        showAlertsList: false,
    }),
    watch: {},
    computed: {
        ...mapState(useAlertsStore, [
            'activeProperty',
            'showAlertModal',
        ]),
    },
    methods: {
        ...mapActions(useAlertsStore, [
            'setShowAlertModal',
            'setActiveProperty',
            'setAlertModalState',
        ]),
        alertType(alert) {
            let formatted;
            if (alert.alert_type === 'specific') {
                formatted = 'Specific Dates';
            }
            if (alert.alert_type === 'flexible') {
                formatted = 'Flexible Dates';
            }
            return formatted;
        },
        alertDates(alert) {
            let formatted;

            if (alert.alert_type === 'specific') {
                formatted =
                    dayjs(alert.check_in).format('M/D/YYYY') +
                    ' - ' +
                    dayjs(alert.check_out).format('M/D/YYYY');
            }

            if (alert.alert_type === 'flexible') {
                formatted =
                    alert.number_of_nights +
                    ' night' +
                    (alert.number_of_nights === 1 ? '' : 's') +
                    ' in ' +
                    dayjs(alert.month_year).format('MMM YYYY');
            }

            return formatted;
        },
        goToAlerts() {
            this.$router.push('/alerts');
        },
        openAlertModal() {
            this.setActiveProperty(this.item);
            if (this.item) {
                this.setAlertModalState('step2.create.property');
            }
            this.setShowAlertModal(true);
        },
    },
    mounted() {},
};
</script>
